import { isEmpty } from 'ramda';
import { getPersistedNameOfSelectedGroup, getPersistedDescriptionOfSelectedGroup } from '../../appSelectors';
import {
    getGroupDescriptionModification,
    getGroupModifications,
    getGroupNameModification,
} from './groupSidebarSelectors';
import type { RootState } from '../../../../configuration/setup/store';

const hasStagedGroupPropertyChanges = (state: RootState) =>
    getGroupNameModification(state) !== '' || getGroupDescriptionModification(state) !== '';

export const getCurrentGroupName = (state: RootState) =>
    hasStagedGroupPropertyChanges(state)
        ? getGroupNameModification(state)
        : (getPersistedNameOfSelectedGroup(state) ?? '');

export const getCurrentGroupDescription = (state: RootState) =>
    hasStagedGroupPropertyChanges(state)
        ? getGroupDescriptionModification(state)
        : (getPersistedDescriptionOfSelectedGroup(state) ?? '');

export const groupSidebarHasRoleChanges = (state: RootState) => {
    const groupModifications = getGroupModifications(state);
    if (!groupModifications) {
        return false;
    }

    return (
        !isEmpty(groupModifications.restrictionsToAdd) ||
        !isEmpty(groupModifications.restrictionsToRemove) ||
        !isEmpty(groupModifications.rolesToAdd) ||
        !isEmpty(groupModifications.rolesToRemove)
    );
};

export const groupSidebarHasPropertyChanges = (state: RootState) =>
    getCurrentGroupName(state) !== getPersistedNameOfSelectedGroup(state) ||
    getCurrentGroupDescription(state) !== getPersistedDescriptionOfSelectedGroup(state);

export const groupSidebarHasChanges = (state: RootState) => {
    return groupSidebarHasRoleChanges(state) || groupSidebarHasPropertyChanges(state);
};
